export const BASKET_TAB_VALUE = 'basket';

export const WISH_LIST_TAB_VALUE = 'wishList';

export const TABS_PAGE = {
  [BASKET_TAB_VALUE]: {
    name: 'Корзина',
    value: BASKET_TAB_VALUE,
  },
  [WISH_LIST_TAB_VALUE]: {
    name: 'Отложенные товары',
    value: WISH_LIST_TAB_VALUE,
  },
  getElements(isAuthorized = false) {
    return isAuthorized ? [this[BASKET_TAB_VALUE], this[WISH_LIST_TAB_VALUE]] : [this[BASKET_TAB_VALUE]];
  },
};

export const TITLE_PAGE = 'Корзина';
